import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import { extraItemServiceDataSchema } from './extra-items.schema';
import { ZodError } from 'zod';
import { toast } from 'react-toastify';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

const axiosInst = axios.create({
  /**
   * "https://dvps74q6bi.execute-api.us-east-2.amazonaws.com/api/user/menu-item"
   */
  baseURL: process.env.REACT_APP_API_BASE_MENUITEM_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosInst);

axiosInst.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

type useGetExtraItemsArg = {
  menuItemId: number;
  enabledIf: boolean;
};

export const useGetExtraItems = (arg: useGetExtraItemsArg) => {
  return useQuery({
    queryKey: ['extra-items', arg.menuItemId],
    queryFn: async () => {
      try {
        const response = await axiosInst.get(`${arg.menuItemId}`);
        const data = extraItemServiceDataSchema.parse(response.data.data);
        return data;
      } catch (error: unknown) {
        if (error instanceof ZodError) {
          console.log(`${process.env.REACT_APP_API_BASE_MENUITEM_URL}/${arg.menuItemId}: `, error?.message);
          toast.error('API validation failed');
        }
        console.error(error);
      }
    },
    enabled: arg.enabledIf,
  });
};
